<!--
  ~ Copyright (c) Worldline 2023.
  -->

<div class="no-js">
    <!-- TODO rewrite SpecificCtrl to allow clients creating their own components MTSSIGNBOX-1551 -->

    <div id="exception">
        <div id="container">

            <div id="cookie-agreement">
                <app-wl-cookie-agreement></app-wl-cookie-agreement>
            </div>

            <header class="container-fluid" role="banner">
                <div class="row">
                    <div class="col-sm-4 col-xs-12">
                        <h1>
                            <img alt="Digital Contract" src="../../../images/logo-default.svg"/>
                        </h1>
                    </div>
                    <div class="col-sm-offset-6 col-sm-2 col-xs-12" [hidden]="true">
                        <div class="form-group">
                            <select class=" form-control" id="language-select"
                                    name="language-select"
                                    (change)="updateLanguage(currentLanguage)"
                                    [(ngModel)]="currentLanguage"
                                    title="{{ 'language.selector' | translate }}">
                                <option lang="fr" value="fr" xml:lang="fr">Fran&ccedil;ais
                                </option>
                                <option lang="en" value="en" xml:lang="en">English</option>
                                <option lang="de" value="de" xml:lang="de">Deutsch</option>
                                <option lang="es" value="es" xml:lang="es">Espa&ntilde;ol
                                </option>
                                <option lang="nl" value="nl" xml:lang="nl">Nederlands</option>
                            </select>
                        </div>
                    </div>
                </div>
            </header>

            <hr/>


            <div class="container-fluid" id="wrapper">
                <ul class="k-form-steps" *ngIf="rootScope.get().step&&!rootScope.get().isSmartphoneType">
                    <li class="{{item(task.value)}} {{fraction()}} {{isActive(task.value)?'active':''}} {{index == 0?'noLeftMargin':''}} "
                        *ngFor="let task of rootScope.get().steps | keyvalue ; let index = index;">
                        <div class="strong" id="step-{{task.value}}">{{ name(task.value) | translate }}</div>
                    </li>
                </ul>

                <div autoscroll="true">
                    <ng-content></ng-content>
                </div>

                <!--                Use different spinners depending on the context in order to avoid conflicts during hide and show with async promises -->
                <ngx-spinner name="spinner" type="line-scale"></ngx-spinner>
                <ngx-spinner name="spinner-bottom" type="line-scale"></ngx-spinner>
                <ngx-spinner name="spinner-pdf" type="line-scale"></ngx-spinner>
                <ngx-spinner name="spinner-pdf-loading" type="line-scale"></ngx-spinner>

            </div>
            <!-- /wrapper -->

            <hr/>

            <footer class="container-fluid" role="contentinfo">
                <div>
                    <app-wl-footer></app-wl-footer>
                </div>
                <p class="k-copyright" id="copyright-message">{{ 'copyright' | translate }}</p>
            </footer>
            <div style="clear:both"></div>
        </div>
    </div>


</div>

